import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import Header from "../components/Header";
import Footer from "../components/Footer";
import { API_BASE_URL } from "../config";

export default function RequestForPrice() {
   const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");

  const [companyId, setCompanyId] = useState(null);
  const [userId, setUserId] = useState(null);

  /* LOAD USER */
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      const user = JSON.parse(storedUser);
      fetchData(user?.companyId, user?.userId);
      setUserId(user.userId);
      setCompanyId(user.companyId);
    }
  }, []);

  /* FETCH DATA ONLY WHEN READY */
  useEffect(() => {
    if (companyId && userId) {
      fetchData(companyId, userId);
    }
  }, [companyId, userId]);

  const fetchData = async (companyId, userId) => {
    setLoading(true);
    try {
      const res = await fetch(
        `${API_BASE_URL}/Price/GetRequestforpriceDetails?CompanyID=${companyId}&UserId=${userId}`
      );
      const json = await res.json();
      setList(json?.data || []);
    } catch (err) {
      console.error("API Error:", err);
      setList([]);
    } finally {
      setLoading(false);
    }
  };

  /* SEARCH FILTER */
  const filteredData = list.filter((item) =>
    Object.values(item)
      .join(" ")
      .toLowerCase()
      .includes(search.toLowerCase())
  );

  return (
    <div className="home">
      <Header />

      <div className="container-fluid my-3">
        <h5>Request For Price</h5>
        <hr />

        {/* SEARCH */}
        <div className="d-flex justify-content-end mb-3">
          <input
            style={{ width: 300 }}
            type="text"
            className="form-control"
            placeholder="Search..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
<br/>
        {/* GRID */}
        <div className="products-list grid">
          <div className="row">

            {loading && (
              <p className="text-center w-100">Loading...</p>
            )}

            {!loading && filteredData.length === 0 && (
              <p className="text-center w-100">No requests found</p>
            )}

            {filteredData.map((item) => {
              const imageSrc =
                item.ProductImg && item.ProductImg.startsWith("https")
                  ? item.ProductImg
                  : "https://westendjewellery.com/assets/Images/UatProduct/default.png";

              return (
                <div
                  className="col-xl-3 col-lg-4 col-md-4 col-sm-6 mb-4"
                  key={item.PriceId || item.RequestId}
                >
                  <div className="customise-product"
                  style={{ cursor: "pointer" }}
            onClick={() =>
              navigate(`/Requestpricedetails/${item.RequestId}`)
            }>

                    {/* IMAGE */}
                    <img
                      src={imageSrc}
                      alt="Product"
                      style={{ width: "100%", borderRadius: "10px" }}
                      onError={(e) => {
                        e.target.src =
                          "https://via.placeholder.com/300x300?text=No+Image";
                      }}
                    />

                    {/* DETAILS */}
                    <div className="details">
                      <div>
                <strong>Request ID:</strong>{" "}
                {item.RequestId}
              </div>
                      <div><strong>Customer:</strong> {item.CustomerName}</div>                      
                      <div><strong>Customer Type:</strong> {item.CustomerType}</div>
                      <div><strong>Product Code:</strong> {item.ProductCode}</div>
                      <div><strong>Design Code:</strong> {item.DesignCode}</div>
                      <div><strong>Metal:</strong> {item.MetalKT} {item.MetalColor} </div>
                     
 <div><strong>Status:</strong> {item.Status}</div>

                      <div>
                        <strong>Request Date:</strong>{" "}
                        {item.RequestDate
                          ? new Date(item.RequestDate).toLocaleDateString()
                          : "-"}
                      </div>

                      <div>
                        <strong>Admin Price:</strong> {item.AdminPrice ?? "-"}
                      </div>

                      <div>
                        <strong>Admin Comment:</strong> {item.AdminComment ?? "-"}
                      </div>
                      <div>
                                                <strong>Last Updated on:</strong>
                                                <span style={{
                                                  backgroundColor:
                                                    item.UpdatedBy === "Admin"
                                                      ? "#FF7074"
                                                      : "white",
                                                  color:
                                                    item.UpdatedBy === "Admin"
                                                      ? "black"
                                                      : "black",
                                                }}>
                                                  {item.AdminDate
                                                    ? new Date(item.AdminDate).getFullYear() === 1900
                                                      ? "-"
                                                      : new Date(item.AdminDate).toLocaleDateString("en-GB")
                                                    : "-"} ({item.UpdatedBy || "-"})
                                                </span>

                                              </div>
                    </div>
 <button
              className="btn btn-view"
              onClick={(e) => {
                e.stopPropagation();
                navigate(
                  `/Requestpricedetails/${item.RequestId}`
                );
              }}
            >
              View Order
            </button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
